import React, { useEffect } from 'react'
import { Layout, Card, Col, Row, Alert } from 'antd'
import Skeleton from 'react-loading-skeleton'
import Sidebar from '../Sidebar/index'
import HorizontalDefault from '../Topbar/HorizontalDefault/index'
import HorizontalDark from '../Topbar/HorizontalDark/index'
import InsideHeader from '../Topbar/InsideHeader/index'
import AboveHeader from '../Topbar/AboveHeader/index'
import BelowHeader from '../Topbar/BelowHeader/index'
// import Marquee from 'react-fast-marquee';
import { footerText } from '../../util/config'
import Topbar from '../Topbar/index'
import { useDispatch, useSelector } from 'react-redux'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import App from '../../routes/index'
import IntlMessages from '../../util/IntlMessages'
import moment from 'moment'
import BuzzTillBannerLogo from '../../assets/images/BUZZTILL_logo_500px.png'

import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from '../../constants/ThemeSetting'
import NoHeaderNotification from '../Topbar/NoHeaderNotification/index'
import { useRouteMatch } from 'react-router-dom'
import tempBuzztill from '../../assets/images/mobile-bg.jpg'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'
import { checkExpiresSub, loadCartClass } from '../../appRedux/actions'

const { Content, Footer } = Layout

const MainApp = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const dispatch = useDispatch()
  const userVerifyCheck = match.url.search('/UserVerify/')

  const showHeaderFooter = useSelector(
    ({ commonConfigs }) => commonConfigs.showHeaderFooter
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const cartMainClass = useSelector(({ MainSale }) => MainSale.cartMainClass)

  // const isMobApp = useSelector(({ commonConfigs }) => commonConfigs.isMobApp)

  const { width, navStyle } = useSelector(({ settings }) => settings)

  // const space_string=""

  //sub date exp check
  const [subLeftDays, setSubLeftDays] = React.useState('')
  const [expireClassName, setExpireClassName] = React.useState('')
  const [showFooter, setShowFooter] = React.useState(true)
  const [showExpiry, setShowExpiry] = React.useState(false)

  React.useEffect(() => {
    checkExpiresOn()
  }, [localStorage.getItem('subscriptionExpiresOn')])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      // NOTE: This check is only to hide footer for cart page
      if (window.location.pathname.toLowerCase().includes('/sell/mainsale')) {
        const daysLeft = checkExpiresSub()
        if (showHeaderFooter) {
          setShowFooter(true)
          if (daysLeft && daysLeft < 15)
            dispatch(loadCartClass('hf-sell-with-Subscription-alert'))
          else dispatch(loadCartClass('hf-sell'))
        } else {
          setShowFooter(false)
          if (daysLeft && daysLeft < 15)
            dispatch(loadCartClass('sell-with-Subscription-alert'))
          else dispatch(loadCartClass(''))
        }
      } else setShowFooter(true)

      return () => (mounted = false)
    }
  }, [showHeaderFooter, window.location.pathname])

  const getContainerClass = navStyle => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-container-wrap'
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-container-wrap'
      default:
        return ''
    }
  }

  const getNavStyles = navStyle => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />
      case NAV_STYLE_FIXED:
        return <Topbar />
      case NAV_STYLE_DRAWER:
        return <Topbar />
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />
      default:
        return null
    }
  }
  const getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) {
      return <Sidebar />
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />
      case NAV_STYLE_DRAWER:
        return <Sidebar />
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />
      default:
        return null
    }
  }

  function parseDate (str) {
    var mdy = str.split('/')
    return new Date(mdy[2], mdy[0] - 1, mdy[1])
  }

  function checkExpiresOn () {
    // const expiresOn = localStorage.getItem('subscriptionExpiresOn')
    // const subEndsOn = moment(expiresOn)
    // const currDate = moment()
    const daysLeft = checkExpiresSub() // dateDiff(currDate, subEndsOn)
    if (daysLeft > 0) {
      setSubLeftDays(daysLeft)
    } else {
      if (userVerifyCheck != 0) {
        setSubLeftDays('0')
        history.push('/Dashboard/billingplans')
      }
    }
    let className = daysLeft > 14 ? 'ant-layout-footer-hide' : ''
    setShowExpiry(daysLeft > 14 ? false : true)
    // dispatch(loadCartClass('sell-with-Subscription-alert'))
    setExpireClassName(className)
  }

  // useEffect(() => {
  //   console.log('web_online_mainapp', JSON.stringify(isOnline))
  // }, [isOnline])

  return (
    <>
      {!isOnline && (
        <div>
          <Alert
            // banner
            className='offline-status-bar'
            message={
              <span className='center-off-message offline-message'>
                You are currently offline
              </span>
            }
            type='error'
            showIcon={false}
          />
        </div>
      )}
      {userVerifyCheck == 0 ? (
        <Layout className='gx-app-layout'>
          {checkIsWeb().exist ? getSidebar(navStyle, width) : ''}
          <Layout>
            <div>
              <Skeleton className='header-skeleton' />
            </div>

            <Content
              className={`gx-layout-content ${getContainerClass(navStyle)}`}
            >
              <App match={match} />
              <Skeleton className='footer-skeleton' />
            </Content>
          </Layout>
        </Layout>
      ) : (
        <Layout className='gx-app-layout'>
          {/* {checkIsWeb().exist ? getSidebar(navStyle, width) : ''} */}
          {getSidebar(navStyle, width)}
          <Layout>
            {
              checkIsWeb().exist ? getNavStyles(navStyle) : ''
              // (
              //   <div>
              //     <Skeleton className='header-skeleton' />
              //   </div>
              // )
            }
            {showExpiry && (
              <Footer className={`${expireClassName} Subscription-wrapper`}>
                <div className='gx-layout-footer-content'>
                  <div className='Subscription-days'>
                    <InfoCircleOutlined />
                    <div className='Subscription-txt'>
                      <IntlMessages
                        id='dashboard.dashboard.activateaccount'
                        description='Activate account message'
                        defaultMessage='You have <strong>{subLeftDays} days</strong> left on your Subscription.'
                        values={{
                          strong: chunks => <strong>{chunks}</strong>,
                          subLeftDays: subLeftDays
                        }}
                      />
                      <a href='dashboard/billingplans'>
                        <IntlMessages id='mainapp.activateaccount' />
                      </a>
                    </div>
                  </div>
                </div>
              </Footer>
            )}
            <Content
              className={`gx-layout-content ${getContainerClass(navStyle)}`}
            >
              <App match={match} />

              {checkIsWeb().exist && showFooter && (
                <Footer style={{ marginTop: 'auto' }}>
                  <div className='gx-layout-footer-content copyright-div'>
                    {footerText + moment().format('YYYY')}
                  </div>
                  <img src={BuzzTillBannerLogo} className='footer-logo-div' />
                  {/* <img src={tempBuzztill} className='footer-logo-div' id='salis' /> \ */}
                </Footer>
              )}

              {/* {'' != null ?

                                <Footer style={{ 'marginTop': 'auto' }}>
                                    <div className="gx-layout-footer-content">
                                        {footerText + moment().format("YYYY")}
                                    </div>
                                </Footer> : <Skeleton className='footer-skeleton' />} */}
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  )
}

export default MainApp
